import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { MutationStateFns } from '@/api/utils/mutation';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_SendEmailByLocation_Conversation = never;

export type ApiRequest_SendEmailByLocation_Conversation = {
  subject: string;
  body: string;
  recipients: string[];
  locationId: number;
  attachments: FileList | null;
};

const METHOD = 'POST_FORM';
const ENDPOINT = 'conversation/send-email';

export const useSendEmailByLocation = (
  stateFns?: MutationStateFns<ApiResponse_SendEmailByLocation_Conversation>
) => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: ApiRequest_SendEmailByLocation_Conversation) =>
      handleApiCall<
        ApiResponse_SendEmailByLocation_Conversation,
        ApiRequest_SendEmailByLocation_Conversation
      >(session, METHOD, getResolvedEndpoint(ENDPOINT, {}), data),
    onSuccess: data => {
      enqueueSnackbar('Email sent successfully.', { variant: 'success' });

      stateFns?.onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      enqueueSnackbar('Failed to send email.', { variant: 'error' });

      stateFns?.onError?.(err);
    },
  });
};
